import { Link } from 'react-router-dom';
import { ArrowRight, Quote } from 'lucide-react';
import { motion } from 'framer-motion';

const testimonials = [
  {
    quote: "DFAIRS transformed our brand presence at the industry expo. Their attention to detail and creative execution exceeded our expectations.",
    author: "Rajesh Kumar",
    position: "Marketing Director",
    company: "Bajaj Electronics",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop"
  },
  {
    quote: "The team's professionalism and innovative approach made our product launch a massive success. Highly recommended for corporate events.",
    author: "Priya Sharma",
    position: "Brand Manager",
    company: "Darwinbox",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop"
  },
  {
    quote: "Exceptional execution of our trade fair booth. They understood our vision perfectly and delivered beyond what we imagined.",
    author: "Arun Mehta",
    position: "CEO",
    company: "Nexus Ventures",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop"
  }
];

export const TestimonialsSection = () => {
  return (
    <section className="py-20 lg:py-32 bg-white" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="inline-block text-gold font-semibold uppercase tracking-wider text-sm mb-4"
          >
            Client Testimonials
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="font-heading text-3xl md:text-4xl lg:text-5xl text-navy mb-6"
          >
            What Our Clients Say
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="text-muted-foreground text-lg"
          >
            Hear from the brands and businesses we've partnered with to create exceptional event experiences.
          </motion.p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-muted p-8 relative hover-lift"
              data-testid={`testimonial-${index}`}
            >
              {/* Quote Icon */}
              <div className="absolute -top-4 -left-2">
                <Quote className="w-12 h-12 text-gold/30 fill-gold/10" />
              </div>

              {/* Quote Text */}
              <p className="text-navy text-lg leading-relaxed mb-8 relative z-10">
                "{testimonial.quote}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-4">
                <img
                  src={testimonial.image}
                  alt={testimonial.author}
                  className="w-14 h-14 rounded-full object-cover border-2 border-gold"
                />
                <div>
                  <div className="font-semibold text-navy">{testimonial.author}</div>
                  <div className="text-muted-foreground text-sm">
                    {testimonial.position}, {testimonial.company}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mt-16"
        >
          <Link 
            to="/contact" 
            className="btn-primary inline-flex items-center gap-2"
            data-testid="testimonials-cta"
          >
            Start Your Project
            <ArrowRight className="w-5 h-5" />
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
